import { BaseComponent } from "../../../../components/BaseComponent";
import React from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import styled from "styled-components";
import {Modal, ModalControls} from "../../../../components/Modal";
import {Button} from "../../../../components/Buttons";
import {selectCompanyTransportLocations} from "../../selectors";
import {fetchCompanyTransportLocations} from "../../actions";
import {selectWork} from "../../../Api/selectors";
import {REQUEST_COMPANY_TRANSPORT_LOCATIONS, REQUEST_EXACT_AUTH_STATUS, REQUEST_INVOICE} from "../../constants";
import {Loader} from "../../../../components/Loader";
import {InvoiceAddress} from "./InvoiceAddress";

const CheckedAddress = styled.div`
  border: 1px solid rgb(247, 247, 247);
`;

const STATE = {
  selectedId: null,
};

const Container = styled.div``;

class InvoiceTransportLocationSelectionComp extends BaseComponent {

  constructor(props) {
    super(props, STATE);
  }
  componentDidMount() {
    this.props.fetchCompanyTransportLocations();
  }

  onClose() {

  }

  onChange() {
    const location = this.props.companyTransportLocations.find(a => a.id === this.state.selectedId);
    this.props.onChange(location);
  }

  onSelect(id) {
    this.updateState('selectedId', id);
  }

  get companyTransportLocations() {
    return this.props.companyTransportLocations ?? [];
  }

  renderLocations() {
    return (
      <React.Fragment>
        {this.companyTransportLocations.map(a => {
          return <InvoiceAddress onSelect={this.onSelect.bind(this)} selected={a.id === this.state.selectedId} key={a.id} address={a} />
        })}
      </React.Fragment>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        <Modal title={this.lbl('invoice.transportLocation.title')}>
          {this.renderLocations()}
          <ModalControls>
            <Button
              disabled={false}
              onClick={this.onChange.bind(this)}
            >
              {this.lbl('save')}
            </Button>
            <Button onClick={this.props.onClose}>{this.lbl('cancel')}</Button>
          </ModalControls>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companyTransportLocations: selectCompanyTransportLocations(),
    work: selectWork(REQUEST_COMPANY_TRANSPORT_LOCATIONS),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCompanyTransportLocations() {
      dispatch(fetchCompanyTransportLocations(ownProps.companyId));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceTransportLocationSelection = compose(
  withConnect,
  withRouter,
)(InvoiceTransportLocationSelectionComp);
